export const FETCH_ADDRESS_REQ = "FETCH_ADDRESS_REQ";
export const FETCH_ADDRESS_SUCCESS = "FETCH_ADDRESS_SUCCESS";
export const FETCH_ADDRESS_FAILURE = "FETCH_ADDRESS_FAILURE";
export const ADD_ADDRESS = "ADD_ADDRESS";
export const EDIT_ADDRESS = "EDIT_ADDRESS";
export const DELETE_ADDRESS = "DELETE_ADDRESS";
export const SELECTED_ADDRESS = "SELECTED_ADDRESS";
export const CLEAR_ADDRESS = "CLEAR_ADDRESS";